export default __webpack_public_path__ + "static/media/MyContactsActive.e2749e21.svg";